module.exports = __webpack_public_path__ + "img/waymaker.0df6d1cf.png";